import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import { Paragraph, View } from '@uncinc/react-drupal-core';

import './style.scss';

const NodeLandingPageCampaign = ({ entity, className }) => {
  const classes = classNames('LandingPageCampaign', className);
  const taxonomyId = entity.getIn(['field_campaign', 0, 'target_id']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="Paragraphs">
        {
          entity.getIn(['field_paragraphs'], List()).map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
      <View id="campaign_projects" display="block_1" args={[taxonomyId]} />
    </article>
  );
};

export default NodeLandingPageCampaign;
